import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Panel, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, addArrayItemField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import TypeaheadGridInput, {matcher} from '../../core/components/TypeaheadGridInput'
import TagBar from '../../core/components/TagBar'
import IconCateg from '../../core/components/IconCateg'
import {CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED, updateCreateOpeningTicketPurposeAction, sendCreateOpeningTicketPurposeAction, loadOpeningTicketPurposeRef} from '../actions'
import {OpeningTicketPurposeRef, CreateOpeningTicketPurposeAction} from '../models'
import i18n from '../i18n'
import style from './CreateOpeningTicketPurposePanel.less'

function childrenCategoryFilter(parentCategory) {
    return (category) => {
        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid)
    }
}

function categoryTagMatcher(categoriesOrTags) {
    return matcher({
        source: categoriesOrTags,
        identify: (cot) => cot.label
    })
}

class CreateOpeningTicketPurposePanel extends Component {
    static propTypes = {
        reference: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this._categoryTagBars = []
        this._categoryTypeaheadGridInputs = []
    }

    _sendAction(event) {
        const {dispatch, onSelect} = this.props

        var openingTicketPurposeUid
        return dispatch(sendCreateOpeningTicketPurposeAction()).then((action) => {
            openingTicketPurposeUid = action.openingTicketPurposeUid
            return dispatch(loadOpeningTicketPurposeRef())
        }).then(() => {
            onSelect(event, openingTicketPurposeUid)
        })
    }

    _submitCreateCategory(event, parentCategory, index) {
        const {dispatch, action, onSubmit} = this.props
        
        const category = {
            label: this._categoryTypeaheadGridInputs[index].getQuery(),
            parent: parentCategory
        }

        onSubmit(event, 'CreateCategory', category).then((category) => {
            const categoryUids = action && action.categoryUids || []
            const index = categoryUids.findIndex((c) => c.uid == (parentCategory && parentCategory.uid))
            
            if (index < 0) {
                categoryUids.unshift(category)
            } else {
                categoryUids[index] = category
            }

            dispatch(updateCreateOpeningTicketPurposeAction({categoryUids}))
        })
    }

    _submitCreateTag(event) {
        const {dispatch, action, onSubmit} = this.props
        
        const tag = {
            label: this._tagTypeaheadGridInput.getQuery()
        }

        onSubmit(event, 'CreateTag', tag).then((tag) => {
            const tagUids = action && action.tagUids || []
            tagUids.unshift(tag)
            
            dispatch(updateCreateOpeningTicketPurposeAction({tagUids}))
        })
    }

    render() {
        const {dispatch, form, action, reference, onSubmit, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const categorySource = (category) => {
            return matcher({
                source: reference.categories.filter(childrenCategoryFilter(category)),
                identify: (c) => c.label
            })
        }

        const tagSource = matcher({
            source: reference.tags,
            identify: (t) => t.label
        })

        const tooltipInputAddon = (text) => (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(text)}>
                <span className={style.info}>?</span>
            </OverlayTrigger>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const displayCategory = (category, active, path) => (
            <div className={style.category}>
                <IconCateg iconId={category.iconId} exponent={active && 'X'}/>
                <label>{category.label}</label>
                {path && (
                    <small>></small>
                )}
            </div>
        )

        const displayTag = (tag, active) => {
            return (
                <div className={style.tag}>
                    <IconCateg iconId={tag.iconId} exponent={active && 'X'}/>
                    <label>{tag.label}</label>
                </div>
            )
        }

        const categoryField = (field, category) => {
            const arrayValue = field.value || []
            const index = arrayValue.indexOf(category)
            const value = arrayValue[index]

            const onChange = (category) => {
                const nextArrayValue = [...arrayValue]
                
                if (category) {
                    nextArrayValue[index] = category
                } else {
                    nextArrayValue.splice(index, 1)
                }

                field.onChange(nextArrayValue)
            }

            return {value, onChange}
        }

        const categoryPathField = (field, category) => {
            const arrayValue = field.value || []
            const index = arrayValue.indexOf(category)
            const value = OpeningTicketPurposeRef.expendParentCategories(reference, category)

            const disabled = (category, index) => {
                return index < value.length - 1
            }

            const onChange = (categories) => {
                const nextValue = OpeningTicketPurposeRef.getLeafCategory(categories)
                const nextArrayValue = [...arrayValue]
                
                if (nextValue) {
                    nextArrayValue[index] = nextValue
                } else {
                    nextArrayValue.splice(index, 1)
                }

                field.onChange(nextArrayValue)
            }

            return {value, disabled, onChange}
        }

        const closeTagTagBarField = (field) => {
            const onChange = (eventOrValue) => {
                this._tagTagBar.close()
                field.onChange(eventOrValue)
            }

            return {...field, onChange}
        }

        const closeCategoryTagBarField = (field, index) => {
            const onChange = (eventOrValue) => {
                this._categoryTagBars[index] && this._categoryTagBars[index].close()
                field.onChange(eventOrValue)
            }

            return {...field, onChange}
        }

        const closeTagTagBar = (next) => {
            return (...args) => {
                this._tagTagBar.close()
                return next(...args)
            }
        }

        const closeCategoryTagBar = (next, index) => {
            return (...args) => {
                this._categoryTagBars[index] && this._categoryTagBars[index].close()
                return next(...args)
            }
        }

        return (
            <Panel
                {...others}>
                <div className={style.defaultContent}>
                    <h4>{i18n.newOpeningTicketPurpose}</h4>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='label'
                            label={requiredLabel(i18n.label)}
                            {...form.label()} />
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='reference'
                            label={i18n.reference}
                            addonAfter={tooltipInputAddon(i18n.referenceInfo)}
                            {...form.extId()} />
                    </form>
                    <Row>
                        <Col sm={3}>
                            <h5>{i18n.categories}</h5>
                        </Col>
                        <Col sm={9}>
                            {action && action.categoryUids && action.categoryUids.slice(0).reverse().map((category, index) => (
                                <div
                                    className={style.categorySection}
                                    key={index}>
                                    <TagBar multi
                                        ref={(tb) => this._categoryTagBars[index] = tb}
                                        display={(c, i, a) => displayCategory(c, i == a.length - 1, true)}
                                        identify={(c) => c.uid}
                                        label={i18n.addChildCategory}
                                        {...categoryPathField(form.categoryUids(), category)}>
                                        <TypeaheadGridInput
                                            ref={(tgi) => this._categoryTypeaheadGridInputs[index] = tgi}
                                            source={categorySource(category)}
                                            identify={(c) => c.uid}
                                            display={displayCategory}
                                            placeholder={i18n.searchCategory}
                                            {...closeCategoryTagBarField(categoryField(form.categoryUids(), category), index)} />
                                        <div className={style.manage}>
                                            <a
                                                href=''
                                                onClick={closeCategoryTagBar((e) => this._submitCreateCategory(e, category, index), index)}>
                                                {i18n.newCategory}
                                            </a>
                                        </div>
                                    </TagBar>
                                </div>
                            ))}
                            <TagBar
                                ref={(tb) => this._categoryTagBars[1000] = tb}
                                value={null}
                                label={i18n.addCategory}>
                                <TypeaheadGridInput
                                    ref={(tgi) => this._categoryTypeaheadGridInputs[1000] = tgi}
                                    source={categorySource()}
                                    identify={(c) => c.uid}
                                    display={displayCategory}
                                    placeholder={i18n.searchCategory}
                                    {...closeCategoryTagBarField(addArrayItemField(form.categoryUids()), 1000)} />
                                <div className={style.manage}>
                                    <a
                                        href=''
                                        onClick={closeCategoryTagBar((e) => this._submitCreateCategory(e, null, 1000), 1000)}>
                                        {i18n.newCategory}
                                    </a>
                                </div>
                            </TagBar>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3}>
                            <h5>{i18n.tags}</h5>
                        </Col>
                        <Col sm={9}>
                            <TagBar multi
                                ref={(tb) => this._tagTagBar = tb}
                                display={(t) => displayTag(t, true)}
                                identify={(t) => t.uid}
                                label={i18n.addTag}
                                {...form.tagUids()}>
                                <TypeaheadGridInput multi
                                    ref={(tgi) => this._tagTypeaheadGridInput = tgi}
                                    source={tagSource}
                                    identify={(t) => t.uid}
                                    display={displayTag}
                                    placeholder={i18n.searchTag}
                                    {...closeTagTagBarField(form.tagUids())} />
                                <div className={style.manage}>
                                    <a
                                        href=''
                                        onClick={closeTagTagBar((e) => this._submitCreateTag(e))}>
                                        {i18n.newTag}
                                    </a>
                                </div>
                            </TagBar>
                        </Col>
                    </Row>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={(e) => form.validate() && this._sendAction(e) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                    </ButtonToolbar>
                </div>
            </Panel>
        )
    }
}

CreateOpeningTicketPurposePanel = connectForm({
    target: 'action',
    schema: CreateOpeningTicketPurposeAction.schema,
    action: CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
})(CreateOpeningTicketPurposePanel)

CreateOpeningTicketPurposePanel = connect((state) => ({
    action: state.reference.createOpeningTicketPurposeAction
}))(CreateOpeningTicketPurposePanel)

export default CreateOpeningTicketPurposePanel


// WEBPACK FOOTER //
// ./lib/reference/components/CreateOpeningTicketPurposePanel.js